import validationMessages from "vee-validate/dist/locale/es";
//citrix.es

const yesNoOptions = [
    {value: "Yes", text: "Sí"},
    {value: "No", text: "No"}
]

export default {
    privacyLinkLabel: "Política de privacidad",
    privacyLink: '/es-es/about/legal/privacy/',
    privacyText: "Citrix procesará sus datos según nuestra",
    resetText: "Si el formulario está rellenado de forma previa y no es usted,",
    resetText2: "para restablecerlo.",
    resetLinkText: "haga clic aquí",
    yes: "Sí",
    no: "No",
    submitBtn: {
        "Submit" : "Enviar",
        "Get the eBook" : "Obtenga el libro electrónico",
        "Watch demo" : "Vea la demo",
        "Get the kit" : "Conseguir el kit",
        "Compare now" : "Comparar ahora",
        "Request a demo": "Solicite una demostración",
        "Request a call": "Solicite una reunión"
    },
    apjPrivacy:{
        title: "Cómo utilizaremos su información personal",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") utilizará y guardará su información personal de acuerdo con las normas y leyes de protección de datos correspondientes y la",
        linkText: "Política de privacidad de Citrix",
        part2: "y en las circunstancias en las que el acceso esté estrictamente restringido. Citrix utilizará su información personal solo como esté definido en este Política de privacidad y no para ningún otro fin. De acuerdo con esta Política de privacidad, Citrix pude confiar el procesamiento de la información personal a empresas nacionales o extranjeras, compartir la información personal con otras oficinas o filiales de Citrix de todo el mundo o enviar la información personal a terceros nacionales o extranjeros. Cuando envíe su información personal a Citrix, consentirá la recopilación y procesamiento de su información personal tal como se describe en la Política de privacidad de Citrix.",
        privacyAccept: "He leído y acepto la Política de privacidad de Citrix"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Compañía"
        },
        "department": {
            label: "Departamento",
            options: [
                { value: "Application Management", text: "Administración de aplicaciones" },
                { value: "Consulting Services", text: "Servicios de consultoría" },
                { value: "Education / Training", text: "Educación/formación" },
                { value: "Engineering", text: "Ingeniería" },
                { value: "Executive Office / Administration", text: "Administración/oficina ejecutiva" },
                { value: "Finance / Accounting", text: "Finanzas/contabilidad" },
                { value: "Human Resources", text: "Recursos humanos" },
                { value: "Information Technology - Systems", text: "Sistemas de tecnologías de la información" },
                { value: "Legal", text: "Legal" },
                { value: "Marketing / PR", text: "Marketing/relaciones públicas" },
                { value: "Networking", text: "Redes" },
                { value: "Operations / Manufacturing", text: "Explotación/fabricación" },
                { value: "Pre-Sales / Technical Support", text: "Soporte técnico/preventas" },
                { value: "Project Management", text: "Gestión de proyectos" },
                { value: "Purchasing", text: "Compras" },
                { value: "Sales / Bus-Corp Development", text: "Desarrollo corporativo/de ventas" },
                { value: "Security", text: "Seguridad" },
                { value: "Web / Online / E-Business", text: "Comercio electrónico/web/en línea" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Industria",
            options: [
                { value: "Agriculture", text: "Agricultura" },
                { value: "Art & Membership", text: "Arte y afiliación" },
                { value: "Business Consulting", text: "Asesoría empresarial" },
                { value: "Charitable/Non-Profit", text: "Benéfica/sin ánimo de lucro" },
                { value: "Consumer Packaged Goods", text: "Bienes de consumo envasados" },
                { value: "E-Commerce", text: "Comercio electrónico" },
                { value: "Conglomerate", text: "Conglomerado" },
                { value: "Construction and Design", text: "Construcción y diseño" },
                { value: "Entertainment", text: "Entretenimiento" },
                { value: "Chemical Manufacturing", text: "Fabricación química" },
                { value: "Pharmaceuticals", text: "Farmacéuticas" },
                { value: "Finance", text: "Finanzas" },
                { value: "Government/State-Province", text: "Gobierno/estado-provincia" },
                { value: "Government/Local", text: "Gobierno/local" },
                { value: "Government/National-Federal", text: "Gobierno/nacional-federal" },
                { value: "Hospitality", text: "Hostelería" },
                { value: "Engineering", text: "Ingeniería" },
                { value: "Real Estate", text: "Inmobiliaria" },
                { value: "Legal", text: "Legal" },
                { value: "Mining - All", text: "Minería - Todas" },
                { value: "Retail/Wholesale", text: "Minoristas/mayoristas" },
                { value: "Oil and Gas", text: "Petróleo y gas" },
                { value: "Service Provider", text: "Proveedor de servicios" },
                { value: "Publishing/Printing", text: "Publicación/impresión" },
                { value: "Manufacturing", text: "Sector de fabricación" },
                { value: "Health Care", text: "Sector de la salud" },
                { value: "Education", text: "Sector educación" },
                { value: "Insurance", text: "Seguros" },
                { value: "Utilities", text: "Servicios" },
                { value: "Household Services", text: "Servicios domésticos" },
                { value: "Business/Personal Services", text: "Servicios empresariales/personales" },
                { value: "Personnel Services", text: "Servicios personales" },
                { value: "Professional Services", text: "Servicios profesionales" },
                { value: "Technology", text: "Tecnología" },
                { value: "Telecommunication", text: "Telecomunicaciones" },
                { value: "Transportation", text: "Transporte" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Tamaño de la empresa",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Tamaño de la empresa",
            options: [
                { value: "5,001 +", text: "5.001 +" },
                { value: "1,001 to 5,000", text: "1.001 a 5.000" },
                { value: "501 to 1,000", text: "501 a 1.000" },
                { value: "251 to 500", text: "251 a 500" },
                { value: "1 to 250", text: "De 1 a 250" }
            ]
        },
        "Address2": {
            label: "Dirección, línea 2"
        },
        "Address3": {
            label: "Dirección, línea 3"
        },
        "city": {
            label: "Ciudad"
        },
        "country": {
            label: "País"
        },
        "email": {
            label: "Correo electrónico de trabajo"
        },
        "firstName": {
            label: "Nombre"
        },
        "lastName": {
            label: "Apellido(s)"
        },
        "phone": {
            label: "Número de teléfono"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Código postal"
        },
        "salutation": {
            label: "Saludo",
            options: [
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Estado/provincia"
        },
        "address": {
            label: "Dirección"
        },
        "Job_Title__c": {
            label: "Puesto laboral",
            options: [
                { value: "System Administrator", text: "Administrador de sistemas" },
                { value: "IT Manager", text: "Administrador de TI" },
                { value: "Analyst", text: "Analista" },
                { value: "Architect", text: "Arquitecto" },
                { value: "Assistant", text: "Asistente" },
                { value: "Consultant", text: "Consultor" },
                { value: "Developer / Programmer", text: "Desarrollador/Programador" },
                { value: "Director", text: "Director" },
                { value: "Student", text: "Estudiante" },
                { value: "Business Manager", text: "Gerente de nogocios" },
                { value: "Network Administrator / Engineer", text: "Ingeniero/Administrador de redes" },
                { value: "C-Level / President / VP", text: "Nivel C/Presidente/Vicepresidente" },
                { value: "Owner / Partner", text: "Propietario/Socio" }
            ]
        },
        "Project_Budget__c": {
            label: "Presupuesto del proyecto",
            options: [
                { value: "Yes", text: "Sí" },
                { value: "No", text: "No" },
                { value: "Unknown", text: "No sabe" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL para seleccionar más de una opción ( máximo de 5 opciones)"
        },
        "Purchase_Timeframe__c": {
            label: "Marco temporal de compra",
            options: [
                { value: "3 months or less", text: "3 meses o menos" },
                { value: "4 to 6 months", text: "De 4 a 6 meses" },
                { value: "7 months or more", text: "7 meses o más" },
                { value: "No time frame", text: "Sin marco temporal" },
                { value: "Unknown", text: "No está seguro" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "¿Podemos enviarle correos electrónicos?",
            options: [
                { value: "Yes", text: "Sí" },
                { value: "No", text: "No" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Sí" },
                { value: "No", text: "No" }
            ]
        },
        "OK_to_Call__c": {
            label: "¿Podemos llamarle por teléfono?",
            options: [
                { value: "Yes", text: "Sí" },
                { value: "No", text: "No" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Contactar con una persona de ventas"
        },
        "Comments_6__c":{
            label: "Comentarios"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Anular suscripción de todas las comunicaciones de marketing por correo electrónico.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Suspender comunicaciones durante 30 días.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "Cómo unos espacios de trabajo digitales, que incluyan aplicaciones, escritorios, archivos y dispositivos móviles, le ayudarán a trabajar mejor allí donde esté.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Cómo acceder de forma segura a todas las aplicaciones, escritorios y datos desde cualquier dispositivo.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Cómo administrar la entrega de aplicaciones monolíticas y basadas en microservicios en un mundo híbrido multinube.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Cómo proporcionar la red siempre lista de alto rendimiento que necesitan sus usuarios.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Cómo detectar amenazas de seguridad y anomalías de rendimiento con análisis e información para detenerlas antes de que sucedan.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Anular suscripción",
        thankyou: "Se han actualizado sus preferencias de correo electrónico. Si se trata de un error o desea revisar sus preferencias, visite nuestro Centro de preferencias en cualquier momento.",
        formDescription: "Lamentamos que nos deje. Vuelva a visitarnos en Citrix.es cuando desee. Añadimos constantemente nuevas funciones y características para asegurarnos de que los productos Citrix son adecuados para usted.",

    },
    preferenceCenter: {
        formTitle: "Centro de preferencias de correo electrónico de Citrix",
        thankyou: "<h3>Cambios de suscripción confirmados.</h3><p>Se han actualizado sus preferencias de correo electrónico.</p>",
        formDescription: "Sus preferencias de correo electrónico y comunicación son importantes para nosotros. Deseamos enviarle información que le ayude a usted y a su organización a impulsar una forma de trabajar mejor.  Actualice las preferencias de correo electrónico de forma que garanticemos que recibe las comunicaciones de Citrix que le interesen.",
        labelOne: "Cuéntenos más sobre usted",
        labelTwo: "¿Sobre qué temas desea recibir información?",
        labelThree: "¿Cómo le gustaría recibir dicha información?",
    },
    validation: validationMessages
}